
import { ChevronUp, ChevronDown, Dot } from "lucide-react";
import React from "react";
import { MobileTooltipWrapper } from "@/components/ui/tooltip";

type SortOption = "none" | "rating-high" | "rating-low";

interface SortIndicatorProps {
  sortBy: SortOption;
  iconSize: number;
  onRatingClick?: () => void;
}

const SortIndicator = ({ sortBy, iconSize, onRatingClick }: SortIndicatorProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onRatingClick) {
      e.stopPropagation();
      onRatingClick();
    }
  };

  const className = `flex-shrink-0 text-muted-foreground ${onRatingClick ? "cursor-pointer" : ""}`;

  if (sortBy === 'rating-high') {
    return (
      <MobileTooltipWrapper content="Sorted by highest rating first. Click to change">
        <span onClick={handleClick}>
          <ChevronUp 
            size={iconSize} 
            className={className} 
            aria-label="Sorted by highest rating"
          />
        </span>
      </MobileTooltipWrapper>
    );
  } else if (sortBy === 'rating-low') {
    return (
      <MobileTooltipWrapper content="Sorted by lowest rating first. Click to change">
        <span onClick={handleClick}>
          <ChevronDown 
            size={iconSize} 
            className={className} 
            aria-label="Sorted by lowest rating"
          />
        </span>
      </MobileTooltipWrapper>
    );
  }
  
  return (
    <MobileTooltipWrapper content="Click to sort by rating">
      <span onClick={handleClick}>
        <Dot
          size={iconSize}
          className="flex-shrink-0 text-muted-foreground opacity-50 cursor-pointer"
          aria-hidden="true"
        />
      </span>
    </MobileTooltipWrapper>
  );
};

export default SortIndicator;
